<template>
  <div class="menu-box">
    <div class="menu-box--title" v-if="title !== ''">{{ title }}</div>
    <template v-if="useMenuItem">
      <MenuItem
        class="menu-box--item"
        :item="item"
        v-for="(item, index) in data"
        @MenuItemClick="onclick(item)"
        :key="index"
      ></MenuItem>
    </template>
    <!-- [TODO] posso spostare questa logica in menu item (useMenuItem diventa la skin di menuItem) ? -->
    <template v-else>
      <div
        class="menu-box--item xs"
        v-for="(item, index) in data"
        :key="index"
        @click="onclick(item)"
      >
        {{ item.text }}
      </div>
    </template>
  </div>
</template>

<script>
import MenuItem from "@/components/MenuItem.vue";
import menuHelper from "@/mixins/menuHelper";
import { mapActions, mapGetters } from "vuex";
export default {
  mixins: [menuHelper],
  props: {
    title: { type: String, default: "" },
    data: { type: Array, default: () => [] },
    useMenuItem: {
      type: Boolean,
      default: true,
    },
    linkType: {
      type: String,
      default: "router",
    },
  },
  components: {
    MenuItem,
  },
  computed: {
    ...mapGetters({ direction: "scroller/direction" }),
  },
  methods: {
    onclick(item) {
      this.setDirection("rtl");
      switch (this.linkType) {
        case "external":
          this.onExternalMenuClick(item);

          break;
        case "modal":
          if (item.internalPdf) {
            this.onExternalMenuClick(item);
          } else {
            this.onModalMenuClick(item);
          }
          break;
        case "router":
          this.onRouterMenuClick(item);
          break;
      }
    },
    ...mapActions({ setDirection: "scroller/setDirection" }),
  },
};
</script>
<style lang="scss" scoped>
.menu-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  height: fit-content;
  margin: toRem(20) 0;

  &--title {
    @include dida-S;
    color: $ui-white;
    margin-bottom: toRem(7);
  }

  &--item {
    margin: toRem(5) 0;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    color: $ui-white;

    &.xs {
      @include small-links;
    }
  }
}

.tablet {
  .menu-box {
    margin: toRem(30) 0;
    &--item {
      margin: toRem(10) 0;
    }
  }
}
</style>
